import { SizeInput } from "./SizeInput";

export function StandflügelBreitenEingabe({ tor }) {
  if (!tor.isDoppeltor || tor.size == null) {
    return null;
  }
  const minMaxBox = tor.sizeRange.flügelBox;
  return (
    <div className={"Auswahl"} role="group" aria-labelledby="standfluegel-label">
      <div className="Headline">
        <label id="standfluegel-label">
          <span dangerouslySetInnerHTML={{ __html: I18N("Standflügelbreite") }}></span>
        </label>
      </div>
      <SizeInput
        key={tor.id + ".standflügel_x"}
        axis="x"
        value={tor.standflügelbreite}
        setter={(value) => (tor.standflügelbreite = value)}
        disabled={!tor.isBreiteKonfigurierbar || !(minMaxBox.min.x + 0.001 < minMaxBox.max.x)}
        min={minMaxBox.min.x}
        max={minMaxBox.max.x}
      />
    </div>
  );
}
